import React from 'react';

import PropTypes from 'prop-types';

const DragNDropContainer = (props) => {
  const {
    className,
    onDragOver,
    onDragLeave,
    onDrop,
    children,
  } = props;
  const onDragOverHandle = (e) => {
    e.preventDefault();
    onDragOver(e);
  };
  const onDragLeaveHandle = (e) => {
    e.preventDefault();
    onDragLeave(e);
  };
  const onDropHandle = (e) => {
    e.preventDefault();
    onDrop(e);
  };

  return (
    <div
      className={className}
      onDragOver={onDragOverHandle}
      onDragLeave={onDragLeaveHandle}
      onDrop={onDropHandle}
    >
      {children}
    </div>
  );
};

DragNDropContainer.propTypes = {
  className: PropTypes.any,
  onDragOver: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
  children: PropTypes.any,
};

export default DragNDropContainer;
